import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Checkbox, Tooltip } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//iconos
import { Add, Assignment, Close, OpenInBrowser, Visibility } from '@material-ui/icons';

//modal
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

//servicios
import { wsGetAll, wsCreate, wsPost } from 'services/WService.js';
import { Link } from 'react-router-dom';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import { wsFindBy } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  pills: {
    color: 'white',
    padding: '5px 8px 5px 8px',
    borderRadius: '10px',
    cursor: 'pointer'
  },
  icon: {
    fontSize: '20px',
    cursor: 'pointer',
    marginLeft: '5px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'DNI', accessor: 'codusu', width: 130 },
  { Header: 'Usuario', accessor: 'login', width: 100 },
  { Header: 'nombre', accessor: 'nombre' },
  {
    Header: 'HR pend.',
    accessor: 'hojasPendientes',
    excelEnabled: false,
    width: 130,
    align: 'center'
  },
  { Header: '# HR', accessor: 'hojas', excelEnabled: false, width: 100, align: 'center' },
  {
    Header: 'HR disp.',
    accessor: 'hojasDisponibles',
    excelEnabled: false,
    width: 120,
    align: 'center'
  },
  { Header: 'Zona', accessor: 'zone_description', width: 100 },
  { Header: 'IMEI', accessor: 'imei', width: 120 },
  { Header: 'Celular', accessor: 'phone', width: 100 },
  { Header: 'Estado', accessor: 'estado_jornada', width: 100 },
  { Header: 'Hora Jornada', accessor: 'hora_apertura', width: 150 },
  { Header: 'Inicio Operación', accessor: 'start_operation_at', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function WorkingBoss(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [processing, setProcessing] = useState(false);
  const [boss, setBoss] = useState([]);
  const [checkeds, setCheckeds] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [base_zone_id, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);

  async function listBoss(search) {
    setDataLoading(true);
    let data = { ...search };
    if (selectedZones.length > 0) {
      data.base_zone_id = selectedZones.map((zone) => zone.id);
    }
    let response = await wsFindBy('deliv/jefe-reparto', data);
    setDataLoading(false);
    if (response.success) setBoss(response.data);
  }

  async function listZones() {
    setDataLoading(true);
    let res = await wsGetAll('base/zone');
    setDataLoading(false);
    if (res.success) {
      setZones(res.data);
      setSelectedZones(res.data);
    }
  }

  /**
   * quitar marcados
   * @param {*id es el item a desmarcar} id
   */
  function deleteRow(id) {
    checkeds.splice(
      checkeds.findIndex((x) => x.id == id),
      1
    );
    setCheckeds([...checkeds]);
  }

  async function initWorking(checkeds) {
    if (checkeds.length < 1) {
      showNotify('Elija almenos un jefe', 'info');
      return;
    }
    let checkedIds = checkeds.map((item) => item.id);
    setDataLoading(true);
    setProcessing(true);
    let response = await wsCreate('deliv/jornada/iniciar-jornada', { usuarios: checkedIds });
    setProcessing(false);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      setCheckeds([]);
      setBoss(response.data);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listZones();
    // listBoss();
  }, []);
  useEffect(() => {
    if (selectedZones.length > 0) {
      listBoss();
    }
  }, [selectedZones]);


  return (
    <>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon pointer="true" color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de jornada de jefes {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <>
            <Checkbox
              edge="start"
              checked={checkeds.length > 0}
              onChange={(e) => {
                if (e.target.checked) {
                  let filtered = boss.filter((item) => item.estado_jornada === null && item.hojasDisponibles.length > 0);
                  setCheckeds(filtered);
                } else {
                  setCheckeds([]);
                }
              }}
              indeterminate={
                checkeds.length < 1
                  ? false
                  : checkeds.length != boss.filter((item) => item.estado_jornada === null).length
              }
              disabled={processing}
              tabIndex={-1}
              style={{ marginLeft: '13px' }}
            />
            <b>Marcar todo</b>
            <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
              <Button
                style={{ marginLeft: '20px' }}
                size="sm"
                onClick={() => initWorking(checkeds)}
                color={props.themeContext.buttonColorWarning}
                disabled={processing}
              >
                Iniciar Jornada
              </Button>
            </AllowedGuard>

            {processing && <div className="lds-dual-ring"></div>}
            <GridContainer>
              <GridItem xs={12} sm={6} md={3}>
                <MultiComplete
                  label="Zonas"
                  selectAll
                  limitTags={1}
                  textField="description"
                  options={base_zone_id}
                  disabled={processing}
                  selected={selectedZones}
                  setSelected={setSelectedZones}
                />
              </GridItem>
            </GridContainer>
          </>
          
          <ReactTable
            excelName="Jornada-de-jefes"
            defaultWidth={1300}
            columns={columns}
            data={boss.map((item, i) => {
              //mapeando listado para las acciones
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    {item.estado_jornada === null ? (
                      <OpenWorkday
                        item={item}
                        checkeds={checkeds}
                        setCheckeds={setCheckeds}
                        deleteRow={deleteRow}
                        disabled={processing}
                      />
                    ) : undefined}

                    {item.estado_jornada === 'C' ? (
                      <ReOpenWorkday item={item} reload={listBoss} showNotify={showNotify} />
                    ) : undefined}

                    {item.hojasDisponibles.length > 0 && item.estado_jornada === 'O' ? (
                      <SyncWorkday item={item} reload={listBoss} showNotify={showNotify} />
                    ) : undefined}
                    {item.estado_jornada === 'O' ? (
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
                        <ButtonDelete
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorDanger}
                          entity={`deliv/jefe-reparto/${item.id}`}
                          reload={listBoss}
                        >
                          <Close />
                        </ButtonDelete>
                      </AllowedGuard>
                    ) : undefined}
                  </div>
                ),
                codusu: (
                  <div className="actions-right">
                    {item.codusu}
                    <Button
                      justIcon
                      round
                      simple
                      color={props.themeContext.buttonColor}
                      disabled={
                        processing === true
                          ? true
                          : item.hojasPendientes.length == 0 && item.hojas.length === 0
                      }
                    >
                      <Link to={`${item.codusu}`}>
                        <Visibility />
                      </Link>
                    </Button>
                  </div>
                ),
                login: item.login,
                nombre: item.nombre,
                hojasPendientes:
                  item.hojasPendientes.length == 0 ? undefined : (
                    <Tooltip title={item.hojasPendientes?.toString() || 'No tiene'} interactive>
                      <span className={classes.pills} style={{ background: '#ff003b' }}>
                        {item.hojasPendientes?.length || 0}
                      </span>
                    </Tooltip>
                  ),
                hojas: (
                  <>
                    <Tooltip title={item.hojas?.toString() || 'No tiene'} interactive>
                      <span
                        className={classes.pills}
                        style={{ background: item.hojas.length > 0 ? '#17b70d' : 'orange' }}
                        onClick={() => {
                          if (item.hojas.length > 0) {
                            window.open('/admin/reparto/operaciones/programacion/', '_blank');
                          }
                        }}
                      >
                        {item.hojas?.length || 0}
                      </span>
                    </Tooltip>
                  </>
                ),
                hojasDisponibles:
                  item.hojasDisponibles.length == 0 ? undefined : (
                    <Tooltip title={item.hojasDisponibles?.toString() || 'No tiene'} interactive>
                      <span className={classes.pills} style={{ background: '#00a1ff' }}>
                        {item.hojasDisponibles?.length || 0}
                      </span>
                    </Tooltip>
                  ),
                imei: item.imei,
                phone: item.phone,
                zone_description: item.zone_description || '-',
                hora_apertura: item.hora_apertura || '-',
                start_operation_at: item.start_operation_at || '-',
                estado_jornada:
                  item.estado_jornada === 'O'
                    ? 'Abierto'
                    : item.estado_jornada === null
                    ? 'Sin abrir'
                    : item.estado_jornada === 'C'
                    ? 'Cerrado'
                    : 'No definido',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});

const OpenWorkday = ({ item, checkeds = [], setCheckeds, deleteRow, disabled }) => {
  return (
    <Checkbox
      edge="start"
      checked={item.estado_jornada !== null ? true : checkeds.some((obj) => obj.id == item.id)}
      onChange={(e) => {
        if (e.target.checked) {
          setCheckeds([...checkeds, item]);
        } else {
          deleteRow(item.id);
        }
      }}
      tabIndex={-1}
      style={{ marginLeft: '0px' }}
      disabled={
        disabled === true
          ? true
          : item.estado_jornada !== null || item.hojasDisponibles?.length === 0
      }
    />
  );
};

const ReOpenWorkday = ({ item, reload, showNotify }) => {
  const classes = useStyles();
  /* <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
  </AllowedGuard> */

  const openWorkdays = async () => {
    if (item.hojasDisponibles.length === 0) {
      showNotify('Debe tener hojas disponibles', 'info');
      return;
    }
    const response = await wsPost(`deliv/jornada/${item.jornada_id}/reabrir`);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  };

  return (
    <Tooltip title="Re-abrir jornada">
      <OpenInBrowser onClick={openWorkdays} className={classes.icon} style={{ color: '#00acc1' }} />
    </Tooltip>
  );
};
const SyncWorkday = ({ item, reload, showNotify }) => {
  const classes = useStyles();
  /* <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
  </AllowedGuard> */

  const syncWork = async () => {
    const response = await wsPost(`deliv/jornada/${item.jornada_id}/agregar-hojas-disponibles`);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  };

  return (
    <Tooltip title="Asignar hojas">
      <Add onClick={syncWork} className={classes.icon} style={{ color: '#4caf50' }} />
    </Tooltip>
  );
};
